import React from 'react';
import { SemanticToastContainer } from 'react-semantic-toasts';
import { useDispatch } from 'react-redux';
import { Button, Segment } from 'semantic-ui-react';
import { doShowChangeUserEmailLogs } from 'state/changeUserEmail/actions';
import ChangeUserEmailForm from './ChangeUserEmailForm';
import ChangeUserEmailLogModal from './ChangeUserEmailLogModal';

function ChangeUserEmailPage() {
  const dispatch = useDispatch();

  return (
    <>
      <SemanticToastContainer />
      <ChangeUserEmailLogModal />
      <h1>Change User Email</h1>
      <br />
      <Button
        basic
        color="black"
        onClick={() => dispatch(doShowChangeUserEmailLogs())}
      >
        Show Logs
      </Button>
      <Segment>
        <h3>Change User Email</h3>
        <ChangeUserEmailForm />
      </Segment>
    </>
  );
}

export default ChangeUserEmailPage;
